import axios from "axios";

export const uploadFile = async (systemUserVO, gatesFileVOToCreate) => {
    try {
        const {data} = await axios.post("/api/file/gatesCreate", {systemUserVO, gatesFileVOToCreate});
        return [data, null];
    } catch(error) {
        return [null, error];
    }
}

export const updateFile = async (systemUserVO, gatesFileVOToCreate) => {
    try {
        const {data} = await axios.post("/api/file/gatesUpdate", {systemUserVO, gatesFileVOToCreate});
        return [data, null];
    } catch(error) {
        return [null, error];
    }
}

export const deleteFile = async (username, fileMetaDataExternalReference) => {
    try {
        const {data} = await axios.delete("/api/file/delete", {data: {username, fileMetaDataExternalReference}});
        return [data, null];
    } catch(error) {
        return [null, error];
    }
}

export const retrieveFile = async (username, fileVOToFind) => {
    try {
        const {data} = await axios.post("/api/file/view", {username, fileVOToFind});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const viewFilesForGatesLibrary = async (username, gatesReportLibraryExternalReference) => {
    try {
        const {data} = await axios.post("/api/file/viewFilesForGatesReportLibrary" , {username, gatesReportLibraryExternalReference});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
